import React from 'react'
import { Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'

function CardWithIcon({className,className2,className3,className4,className5,link,child}) {
  return (
    <>
    <Card className={className}>
        <Card.Body className={className2}>
          <Link to={link} className={className3}>
            <i className={className4}></i>
            <div className={className5}>{child}</div>
          </Link>
        </Card.Body>
    </Card>
    </>
  )
}

export default CardWithIcon